import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import contactImg from "../assest/images/contact-us/cloud.webp";
import { Helmet } from "react-helmet-async";
import icon from "../assest/images/icons/address.svg";
import icon1 from "../assest/images/icons/call.svg";
import icon2 from "../assest/images/icons/email.svg";
import icon3 from "../assest/images/icons/clock.svg";
import contactImg1 from "../assest/images/contact-us/support.jpg";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";
import Loader from "../component/loader.jsx";

function Contact() {
  const { pathname } = useLocation();
  const [siteData, setSiteData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const SiteApi = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("site-settings");
      setIsLoading(false);
      if (res?.success) {
        setSiteData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    SiteApi();
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "", // Input field का 'name' attribute यही रखें
  });

  // 2. इनपुट बदलने पर स्टेट अपडेट करने के लिए
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // 3. फॉर्म सबमिट करते समय API कॉल
  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    // अगर आपकी API को 'comments' की जगह 'message' नाम से डेटा चाहिए,
    // तो यहाँ उसे बदल कर भेजें:
    const payload = {
      ...formData,
      message: formData.message, // यहाँ मैपिंग करें
      date: formData.travel_date, // यहाँ मैपिंग करें
    };

    try {
      const res = await apiRequest("enquiry", "POST", payload);
      console.log("API Response:", res); //
      setIsLoading(false);
      if (res?.status) {
        successAlert(res.message);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.error("enquiry error", error);
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Helmet>
        <title>Contact Ladakh Tour Operator | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Contact Ladakh MotoDrive for Ladakh tour bookings, bike rentals & travel queries. Plan your Leh trip with our local experts."
        />

        <meta
          name="keywords"
          content="contact ladakh motodrive, ladakh tour booking contact, leh travel agent contact, ladakh bike rental contact, ladakh tour enquiry, leh tour operator phone number"
        />

        <link rel="canonical" href="https://ladakhmotodrive.com/contact-us" />

        {/* Open Graph */}
        <meta property="og:title" content="" />
        <meta
          property="og:description"
          content="Contact Ladakh MotoDrive for Ladakh tour bookings, bike rentals & travel queries. Plan your Leh trip with our local experts."
        />
        <meta
          property="og:url"
          content="Contact Ladakh Tour Operator | Ladakh MotoDrive"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Ladakh Tour Operator | Ladakh MotoDrive"
        />
        <meta
          name="twitter:description"
          content="Contact Ladakh MotoDrive for Ladakh tour bookings, bike rentals & travel queries. Plan your Leh trip with our local experts."
        />
      </Helmet>
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Contact Us</h3>
            <ul className="breadcrumb-menu">
              <li>
                <a className="text-white" href="index.html">
                  Home
                </a>
              </li>
              <li>-</li>
              <li className="active">Contact Us</li>
            </ul>
          </div>
        </div>
      </div>

      <section className=" home-destination bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="contact-box">
                <div className="imedia">
                  <img src={icon} alt="address" />
                </div>

                <div className="content">
                  <h3>Office Address</h3>
                  <p>{siteData?.site_address}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="contact-box">
                <div className="imedia">
                  <img src={icon1} alt="phone" />
                </div>

                <div className="content">
                  <h3>Call Us</h3>
                  <p>{siteData?.site_contact_number} </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="contact-box">
                <div className="imedia">
                  <img src={icon2} alt="email" />
                </div>

                <div className="content">
                  <h3>Email Us</h3>
                  <p>{siteData?.site_email_address} </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="contact-box">
                <div className="imedia">
                  <img src={icon3} alt="clock" />
                </div>

                <div className="content">
                  <h3>Open Time</h3>
                  <p>Mon - Sat (10.00AM - 05.30PM) </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-destination bg-light pt-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 align-self-center">
              <div className="contact-image">
                <img src={contactImg1} alt="contact" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="contact-form-box">
                <h2 className="title">Get In Touch</h2>

                <p className="desc">
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page randomised words which don't
                  look even slightly when looking at its layout.
                </p>

                <form className="map-from" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="input-group">
                      <label>Your Name</label>
                      <input
                        className="form-control"
                        name="name"
                        placeholder="Your full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="input-group">
                      <label>Your Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="youremail@domain.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="input-group textarea">
                    <textarea
                      className="form-control"
                      name="message"
                      rows="3"
                      placeholder="Tell us about your travel plans..."
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>

                  <button className="send-btn">Send Message ✈</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className=" home-destination bg-light pt-0">
        <div className="container">
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1712128.8524458348!2d76.54010834399753!3d34.152586411545645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38f109403309a4d5%3A0x679051566f108f9a!2sLadakh!5e0!3m2!1sen!2sin!4v1710321234567!5m2!1sen!2sin"
              width="100%" // चौड़ाई को रिस्पॉन्सिव बनाने के लिए 100% रखें
              height="450"
              style={{ border: 0 }} // React में style ऑब्जेक्ट की तरह दी जाती है
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ladakh Map"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
